import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withRouter } from 'react-router';
import Icon from '@material-ui/core/Icon';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { Link } from 'react-router-dom';


// import Payment from '../../icons/Payment';
import OrderHistory from '../../icons/OrderHistory';
import Logout from '../../icons/Logout';
import useAuth from '../../hooks/auth';
import useServiceWorker from '../../hooks/service-worker';
import AppInstallBanner from '../app-install-banner/AppInstallBanner';
import usePod from '../../hooks/pods';
import Wallet from '../../icons/Wallet';
import useOrder from '../../hooks/orders';
import useFirebase from '../../hooks/firebase';
import useRating from '../../hooks/rating';
import Tips from '../../icons/Tips';
import useTips from '../../hooks/tips';
import config from '../../config';
import useUser from '../../hooks/user';

const useStyles = makeStyles({
	list: {
		width: 250,
	},
	paperAnchorLeft: {
		backgroundColor: '#f05b83',
		padding: '10px 0',
	},
	itemIcon: {
		color: 'white',
		minWidth: '40px',
	},
	listItem: {
		color: 'white',
		'& .MuiListItemText-primary': {
			fontWeight: 500,
		},
	},
	installBanner: {
		'& > div': {
			margin: '0 0 10px !important',
			padding: '0 !important',
		},
		'& .MuiButton-contained': {
			alignSelf: 'flex-end',
		},
	},
	termsLink: {
		color: 'white',
		textDecoration: 'none',
		display: 'inline-block',
		marginBottom: 4,
	}
});

const TmDrawer = ({ open, toggleDrawer, history }) => {
	const classes = useStyles();
	const [{ sessionId }, , logout] = useAuth();
	const [{ appInstalled = false, promptEvent } = {}] = useServiceWorker();
	const [{ selectedPod = null, affiliateData = null, affiliateActive } = {}] = usePod();
	const [orderState, , , handleSelectOrder] = useOrder();
	const { orderHistory } = orderState;
	const [logEvent] = useFirebase();
	const [, , toggleRatingDlgCb] = useRating();
	const [, toggleTips] = useTips();
	const [{ mobile } = {}] = useUser();

	const closeDrawer = (value) => {
		switch (value) {
			case 'PASSBOOK':
				history.push('/passbook');
				break;

			case 'WALLET':
				history.push('/wallet');
				break;

			case 'ORDER_HISTORY':
				history.push('/orders/order-history');
				break;

			case 'LOGOUT':
				logout();
				history.push('/login');
				break;

			case 'SUPPORT':
				if (orderHistory && orderHistory.length > 0) {
					handleSelectOrder(orderHistory[0]);
					history.push(`/orders/${orderHistory[0].order_id}/help`);
					return logEvent('view_support_options');
				}
				return history.push('/orders/order-history');

			case 'SHOP':
				if (affiliateActive && affiliateData) {
					const { url } = affiliateData;
					if (url) {
						return history.push(url, { navigated: true });
					}
				}
				if (selectedPod) {
					return history.push('/products');
				}

				if (orderHistory && orderHistory.length > 0) {
					return history.push({
						pathname: '/products',
						state: { selectPod: orderHistory[0].vm_imei_id },
					});
				}
				return history.push('podlist');

			case 'FEEDBACK':
				toggleRatingDlgCb(true);
				break;

			case 'TIPS':
				toggleTips(true);
				break;

			case 'ADDRESS':
				return history.push('/address');

			case 'LOGIN':
				return history.push('/login');

			default:
				break;
		}

		toggleDrawer(false);
	};

	return (
		<Drawer open={open} onClose={() => toggleDrawer(false)} classes={{ paperAnchorLeft: classes.paperAnchorLeft }}>
			<List className={classes.list}>
				{/* <ListItem button key='passbook' onClick={() => closeDrawer('PASSBOOK')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Payment />
					</ListItemIcon>
					<ListItemText primary='Passbook' />
				</ListItem> */}
				<ListItem button key='support' onClick={() => closeDrawer('SUPPORT')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Icon classes={{ root: classes.menu }}> help_outline </Icon>
					</ListItemIcon>
					<ListItemText primary='Support' />
				</ListItem>
				<ListItem button key='tips' onClick={() => closeDrawer('TIPS')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Tips />
					</ListItemIcon>
					<ListItemText primary='Tips' />
				</ListItem>
				<ListItem button key='feedback' onClick={() => closeDrawer('FEEDBACK')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Icon classes={{ root: classes.menu }}> feedback </Icon>
					</ListItemIcon>
					<ListItemText primary='Feedback' />
				</ListItem>
				<ListItem button key='shop' onClick={() => closeDrawer('SHOP')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Icon classes={{ root: classes.menu }}> add_shopping_cart </Icon>
					</ListItemIcon>
					<ListItemText primary='Shop' />
				</ListItem>
				<ListItem button key='wallet' onClick={() => closeDrawer('WALLET')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<Wallet />
					</ListItemIcon>
					<ListItemText primary='Wallet' />
				</ListItem>
				<ListItem
					button
					key='orderHistory'
					onClick={() => closeDrawer('ORDER_HISTORY')}
					classes={{ root: classes.listItem }}
				>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<OrderHistory />
					</ListItemIcon>
					<ListItemText primary='Orders' />
				</ListItem>
				<ListItem button key='address' onClick={() => closeDrawer('ADDRESS')} classes={{ root: classes.listItem }}>
					<ListItemIcon classes={{ root: classes.itemIcon }}>
						<LocationOnOutlinedIcon className={classes.locationIcon} />
					</ListItemIcon>
					<ListItemText primary='Address' />
				</ListItem>
				{sessionId && mobile ? (
					<ListItem button key='logout' onClick={() => closeDrawer('LOGOUT')} classes={{ root: classes.listItem }}>
						<ListItemIcon classes={{ root: classes.itemIcon }}>
							<Logout />
						</ListItemIcon>
						<ListItemText primary='Logout' />
					</ListItem>
				) : (
					<ListItem button key='logout' onClick={() => closeDrawer('LOGIN')} classes={{ root: classes.listItem }}>
						<ListItemIcon classes={{ root: classes.itemIcon }}>
							<Logout />
						</ListItemIcon>
						<ListItemText primary='Login' />
					</ListItem>
				)}
			</List>
			<section style={{ position: 'absolute', bottom: 0, width: '100%' }}>
				<header
					style={{
						color: 'white',
						textAlign: 'center',
						fontSize: '16px',
						marginBottom: '10px',
					}}
				>
					<Link to="/terms-and-conditions" className={classes.termsLink}>Terms & conditions</Link>
					<div>{config.RELEASE_VER}</div>
				</header>
				{!appInstalled && promptEvent && (
					<AppInstallBanner
						closeBtn={false}
						icon
						className={classes.installBanner}
						style={{
							flexDirection: 'column',
							padding: '10px',
							height: 'unset',
							alignItems: 'flexStart',
							position: 'unset',
							width: 'inherit',
						}}
					/>
				)}
			</section>
		</Drawer>
	);
};

export default React.memo(withRouter(TmDrawer));
